import { Context } from './Context';
import { useStreamWorkflowCheck } from './useStreamWorkflowCheck';
export function WorkflowCheckProvider(props) {
    const { type, documentId, children } = props;
    const { startWorkflowCheck, resetWorkflowCheck, rerunWorkflowCheck, state, approvalResult, signatoryResult, error } = useStreamWorkflowCheck(documentId, type);
    const startCheck = (workflowId) => {
        startWorkflowCheck(workflowId);
    };
    const rerunCheck = (context) => {
        rerunWorkflowCheck(context);
    };
    const resetCheck = () => {
        resetWorkflowCheck();
    };
    const value = {
        state,
        error,
        approvalResult,
        signatoryResult,
        startCheck,
        rerunCheck,
        resetCheck,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
